import { twMerge } from 'tailwind-merge';

import { randomSeed } from '@/renderer/utils/randomSeed';

const COLORS = [
  'bg-orange-500',
  'bg-yellow-500',
  'bg-lime-500',
  'bg-cyan-500',
  'bg-sky-500',
  'bg-blue-500',
  'bg-indigo-500',
  'bg-violet-500',
  'bg-purple-500',
  'bg-fuchsia-500',
  'bg-pink-500',
  'bg-rose-500',
] as const;

export default function Avatar({
  user,
  isAdmin,
}: {
  user?: { firstName: string; lastName: string; id: API.Id };
  isAdmin?: boolean;
} = {}) {
  const random = randomSeed(`${user?.id}`);
  const bg = COLORS[Math.floor(random * COLORS.length - 0.0001)];

  return (
    <div
      className={twMerge(
        'relative mt-[3px] inline-flex h-8 w-8 select-none items-center justify-center rounded-sm',
        bg,
        isAdmin && 'bg-emerald-700 dark:bg-emerald-500',
      )}
    >
      {/* {isAdmin && <Logo height={16} className="select-none absolute -bottom-2 -right-2 h-4 w-4 rounded-sm opacity-75" />} */}
      <span className="select-none uppercase text-white">
        {user?.firstName?.charAt(0)}
        {user?.lastName?.charAt(0)}
      </span>
    </div>
  );
}
